// @ts-nocheck
export default function preg_replace(find, replace, source){
	let replaceString = source.toString();
	for (let i = 0; i < find.length; i++) {
		let regex = new RegExp(find[i], "g");
		replaceString = replaceString.replace(regex, replace[i]);
	}

	return replaceString;
}
